import React from 'react';

import DeNavButton from './shared/DeNavButton';
import { _navItems } from '../../util/deUtils';

const DeLeftNavigations = () => {
  const _renderLftNav = () => {
    const navs = _navItems.map(nav => {
      return (
        <div key={nav.id} className="de--nav--item">
          <DeNavButton
            location={nav.path}
            label={nav.title}
            icon={<nav.icon />}
          />
        </div>
      );
    });
    return navs;
  };

  return (
    <div className="de--nav--root" data-test="deToolPaletteComponent">
      <div className="de--nav">{_renderLftNav()}</div>
    </div>
  );
}

export default DeLeftNavigations;
